import axios from "src/lib/axios";

export const getBanners = async (bannerKey, resource) => {
  const { data: response } = await axios.get(
    `/banners/${bannerKey}/${resource}`
  );
  return response.data;
};

export const addBanner = async (bannerKey, resource, newBanner) => {
  const { data: response } = await axios.post(
    `/banners/${bannerKey}/${resource}`,
    newBanner,
    {
      headers: {
        "Content-Type": "multipart/form-data", // do not forget this
      },
    }
  );
  return response.data;
};

export const updateBanner = async (bannerKey, resource, updatedBanner) => {
  const { data: response } = await axios.put(
    `/banners/${bannerKey}/${resource}`,
    updatedBanner,
    {
      headers: {
        "Content-Type": "multipart/form-data", // do not forget this
      },
    }
  );
  return response.data;
};

export const updateBanners = async (bannerKey, resource, updatedBanners) => {
  const { data: response } = await axios.put(
    `/banners/${bannerKey}/${resource}/position`,
    updatedBanners
  );
  return response.data;
};

export const deleteBanner = async (bannerKey, resource, position) => {
  const { data: response } = await axios.delete(
    `/banners/${bannerKey}/${resource}/${position}`
  );
  return response.data;
};

export const toggleVisibility = async (bannerKey, resource, position) => {
  const { data: response } = await axios.patch(
    `/banners/${bannerKey}/${resource}/${position}`
  );
  return response.data;
};
